/*
 * Service loadArticleInfo, replace event communication
 */
angular.module('posApp').factory('loadArticleInfo', () => {
  const loadArticleInfo = function (pageRef) {
    loadArticleInfo.pageRef = pageRef;
  };

  return loadArticleInfo;
});
